export default __webpack_public_path__ + "static/media/redditNew.894e576f.svg";